export const ageMethod = "age last";
export const gateway = "https://api-cmf-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://api-assets.link-nonprod.wawanesalife.com/brokers/cmf";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJjbWYiLCJuYW1lIjoiY21mIiwiaWF0IjoxNzU2MjIxODk5LCJleHAiOjE5MTQwMDk4OTl9.3T7BdbgkT-Nxg7X0KosPoG7v59hcjGtvLA1eV5KgQiE";
export const brokerConfig = {
	enabled: "yes",
	authorized_nb: "yes",
	authorized_mb: "yes",
	authorized_pe: "yes",
	authorized_yt: "yes",
	authorized_sk: "yes",
	authorized_qc: "no",
	authorized_nt: "yes",
	authorized_nu: "yes",
	authorized_ns: "yes",
	authorized_nl: "yes",
	authorized_on: "yes",
	authorized_ab: "yes",
	authorized_bc: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"api-cmf-shopper.link-nonprod.wawanesalife.com": {
		a: {
			accessibilityLink: "https://en.wikipedia.org/wiki/Web_Content_Accessibility_Guidelines",
			approve_company: "Link Platform",
			approve_user: "link_cmf",
			brands: [
				"api-cmf-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "cmf",
			broker_formatted_name: "Clarence & Main Financial",
			email: "team@clarencemainfinancial.com",
			environment: "api",
			environment_id: "api",
			ftcLink: "https://www.fsrao.ca/regulation/guidance/fair-treatment-customers-insurance",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"True North Tower": [
					"236 Carlton",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
				"River Park branch": [
					"845 Dakota St Unit 30",
					"Winnipeg",
					"MB",
					"R2M 5M3",
				],
				"Jack Blick branch": [
					"1440 Jack Blick Ave",
					"Winnipeg",
					"MB",
					"R3G 0L4",
				],
				"Saskatoon branch": [
					"100-3020 Preston Ave S",
					"Saskatoon",
					"SK",
					"S7T 0V2",
				],
				"Waverley branch": [
					"840 Waverley St",
					"Winnipeg",
					"MB",
					"R3T 5Z7",
				],
			},
			menuPhone: "button",
			phone: "204.555.4321",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
				"carousel6.jpg",
				"carousel7.jpg",
				"carousel8.jpg",
				"carousel9.jpg",
				"carousel10.jpg",
				"carousel11.jpg",
			],
			privacyLink: "https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/",
			themeSwitcher: "show",
			video_link: "SF1CFpZI1tY",
			website: "https://clarencemainfinancial.com/",
			scope: "cmf#branding#api-cmf-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "api-cmf-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://en.wikipedia.org/wiki/Web_Content_Accessibility_Guidelines",
			approve_company: "Link Platform",
			approve_user: "link_cmf",
			brands: [
				"api-cmf-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "cmf",
			broker_formatted_name: "Clarence & Main Financial",
			email: "team@clarencemainfinancial.com",
			environment: "api",
			environment_id: "api",
			ftcLink: "https://www.fsrao.ca/regulation/guidance/fair-treatment-customers-insurance",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"True North Tower": [
					"236 Carlton",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
				"River Park branch": [
					"845 Dakota St Unit 30",
					"Winnipeg",
					"MB",
					"R2M 5M3",
				],
				"Jack Blick branch": [
					"1440 Jack Blick Ave",
					"Winnipeg",
					"MB",
					"R3G 0L4",
				],
				"Saskatoon branch": [
					"100-3020 Preston Ave S",
					"Saskatoon",
					"SK",
					"S7T 0V2",
				],
				"Waverley branch": [
					"840 Waverley St",
					"Winnipeg",
					"MB",
					"R3T 5Z7",
				],
			},
			menuPhone: "button",
			phone: "204.555.4321",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
				"carousel6.jpg",
				"carousel7.jpg",
				"carousel8.jpg",
				"carousel9.jpg",
				"carousel10.jpg",
				"carousel11.jpg",
			],
			privacyLink: "https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/",
			themeSwitcher: "show",
			video_link: "SF1CFpZI1tY",
			website: "https://clarencemainfinancial.com/",
			scope: "cmf#branding#api-cmf-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "api-cmf-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Tue Aug 26 2025 10:24:59 GMT-0500 (Central Daylight Time)
